import React, { useEffect, useState, useRef } from 'react';
import { DonutChartProps } from './types';
import style from './style.module.scss';
import cx from 'classnames';

export const DonutChart: React.FC<DonutChartProps> = (props) => {
  const { progress, variant, children } = props;
  const radius = 30;
  const circumference = 2 * Math.PI * radius;

  const [offset, setOffset] = useState(circumference);
  const circleRef = useRef(null);

  useEffect(() => {
    const progressOffset = ((100 - (progress <= 100 ? progress : 100)) / 100) * circumference;
    setOffset(progressOffset);
  }, [progress]);

  return (
    <div className={cx(style.donutChart, variant === 'secondary' ? style.secondary : style.primary)}>
      <svg className={style.svg} height="100%" width="100%" viewBox="0 0 100 70">
        <circle className={style.svgCircleBg} cx={50} cy={35} r={radius} />
        <circle
          className={style.svgCircle}
          ref={circleRef}
          cx={50}
          cy={35}
          r={radius}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform="rotate(-90 50 35)"
        />
      </svg>
      <div className={style.content}>{children}</div>
    </div>
  );
};

export default DonutChart;
